import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
var listeners = {};
var initialized = false;

var onClickOutside = function onClickOutside(e) {
  _.forEach(listeners, function (listener) {
    if (!listener) {
      return;
    }

    var isClickInside = _.isElement(e.target) && listener.node.contains(e.target);

    if (!isClickInside) {
      listener.method(e);
    }
  });
};

var withClickOutside = function withClickOutside(Component) {
  var ClickOutside = /*#__PURE__*/function (_React$Component) {
    _inherits(ClickOutside, _React$Component);

    var _super = _createSuper(ClickOutside);

    function ClickOutside(props) {
      var _this;

      _classCallCheck(this, ClickOutside);

      _this = _super.call(this, props);
      _this.callbacks = [];

      _this.registerOnClickOutside = function (method, node) {
        var id = _.uniqueId();

        _this.callbacks.push(_.assign({
          method: method,
          id: id
        }, node ? {
          node: node
        } : {}));

        return id;
      };

      _this.clearOnClickOutside = function (id) {
        _this.callbacks = _.reject(_this.callbacks, {
          id: id
        });
        delete listeners[id];
      };

      _this.createListeners = function () {
        var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));

        _.forEach(_this.callbacks, function (callback) {
          listeners[callback.id] = _.assign({
            node: rootNode
          }, callback);
        });
      };

      _this.initialize = function () {
        if (!initialized) {
          window.addEventListener('click', onClickOutside, true);
          initialized = true;
        }
      };

      return _this;
    }

    _createClass(ClickOutside, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initialize();
        this.createListeners();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _.forEach(this.callbacks, function (callback) {
          delete listeners[callback.id];
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = _.assign({}, this.props, {
          onClickOutside: this.registerOnClickOutside,
          clearOnClickOutside: this.clearOnClickOutside
        });

        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);

    return ClickOutside;
  }(React.Component);

  return ClickOutside;
};

export default withClickOutside;